<template>
  <div class='sign' :style="'background-image: url('+HOST+bkimg+');padding-top:'+paddingTop+'vh'">
    <div class="signdiv">
      <div class="text-center" style="font-weight:bold" :style="'color:'+color+';margin-bottom:'+marginBottom+'px'" v-if="time!=''">报名截止时间：<br /><span :style="'color:'+color2">{{time}}</span></div>
      <div :style="'width:'+width+';margin-left:'+left">
        <div v-for="(item,index) in info" :key="index" :style="'margin-bottom:'+marginBottom+'px'">
          <el-input size="mini" v-model="item.detail" v-if="item.type=='input'" :placeholder="item.placeholder==''?'请输入'+item.title:item.placeholder"></el-input>
          <el-select v-model="item.detail" :placeholder="item.placeholder==''?'请选择'+item.title:item.placeholder" size='mini' v-if="item.type=='select'" style="width:100%">
            <el-option v-for="(i, k) in item.select" :key="k" :label="i.title" :value="k"></el-option>
          </el-select>
        </div>
        <el-button type='primary' @click="sign">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      info: [],
      slctDep: '',
      openid: '',
      avator: '',
      bkimg: '',
      endtime: '',
      time: "",
      width: '60%',
      color: 'white',
      color2: 'red',
      marginBottom: 20,
      paddingTop: 10
    };
  },
  mounted() {
    // this.request();
  },
  computed: {
    left() {
      return (100 - parseInt(this.width)) / 2 + '%'
    }
  },
  methods: {
    getUrlKey(name) {//获取url 参数
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null;
    },
    sign() {
      let data = [];
      for (let item in this.info) {
        let crntinfo = this.info[item];
        if (crntinfo.detail === '') {
          this.$message({
            type: 'error',
            message: "请填写" + crntinfo.title
          })
          return;
        }
        data.push(crntinfo);
      }
      this.$axios({
        url: this.HOST + '/member.login/sign',
        method: 'post',
        data: {
          openid: this.openid,
          info: data
        }
      }).then(res => {
        if (res.data.status == 1) {
          this.$message({
            type: 'success',
            message: '报名成功'
          })
        }
      });
    }
  },
  created() {
    let code = this.getUrlKey('code');
    if (code) {
      this.$axios({
        url: this.HOST + '/member.login/login',
        method: 'post',
        data: {
          code: code
        }
      }).then(res => {
        if (res.data.status == 1) {
          this.title = res.data.title;
          this.bkimg = res.data.bkimg;
          this.width = res.data.width;
          this.marginBottom = res.data.marginbottom;
          this.color = res.data.color;
          this.color2 = res.data.color2;
          this.paddingTop = res.data.margintop;
          document.title = res.data.webname;
          if (res.data.successinfo) {
            this.successinfo = res.data.successinfo;
          } else {
            this.openid = res.data.openid;
            this.info = res.data.info;
            setInterval(() => {
              let crnt = Date.now();
              crnt = parseInt(crnt / 1000);
              crnt = res.data.endtime - crnt; console.log(crnt);
              let temp = '';
              if (crnt > 86400) {
                temp = parseInt(crnt / 86400) + '天';
                crnt = crnt % 86400;
              }
              if (crnt > 3600) {
                temp += parseInt(crnt / 3600) + '小时';
                crnt = crnt % 3600;
              }
              if (crnt > 60) {
                temp += parseInt(crnt / 60) + '分钟';
                crnt = crnt % 60;
              }
              temp += crnt + '秒';
              this.time = temp;
            }, 1000);
          }
        }
      });
    } else {
      let url = 'http://auth.qlsww.com/auth/get?license=baoming';
      // let url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxefc403f992b130a4&redirect_uri=" + window.location.href + "&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect";
      window.location.replace(url)
    }
  }
};
</script>